<div class="meeting-join-widget" *ngIf="!meeting?.user_service_contract_id">
  <qrcode *ngIf="isBrowser && joinMeetingUrl"
          [qrdata]="joinMeetingUrl"
          [width]="150"
          [errorCorrectionLevel]="'low'"
          [elementType]="'svg'">
  </qrcode>
  <div class="note">{{ 'meetings.join.qr-code-note' | customLocale }}</div>
</div>
